import React from 'react';
import parse from 'html-react-parser';
import { TermsContainer } from './styles';
var FieldRead = function (_a) {
    var field = _a.field;
    return (React.createElement(TermsContainer, null, parse(field.value || '')));
};
export default FieldRead;
